/* RULY HAIRSTYLIST — theme.js */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = window.RULY && window.RULY.moneyFormat ? window.RULY.moneyFormat : '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace('{{amount}}', parts.join('.'))
      .replace('{{amount_no_decimals}}', parts[0])
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace('{{amount_no_decimals_with_comma_separator}}', parts[0]);
  };
  window.RULY = window.RULY || {};
  window.RULY.money = money;

  /* ---------- Toast ---------- */
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.setAttribute('data-open', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.setAttribute('data-open', 'false'); }, 3800);
  }
  window.RULY.toast = toast;

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-nav-open]');
    var close = e.target.closest('[data-nav-close]');
    var drawer = document.getElementById('nav-drawer');
    if (!drawer) return;
    if (open) {
      drawer.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    if (close) {
      drawer.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var drawer = document.getElementById('nav-drawer');
    if (drawer && drawer.getAttribute('data-open') === 'true') {
      drawer.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
    }
  });

  /* ---------- Cart count ---------- */
  function refreshCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }
  window.RULY.refreshCount = refreshCount;

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var errBox = form.querySelector('[data-form-error]');
    if (errBox) errBox.textContent = '';

    // Booking forms must have a date + time chosen.
    if (form.hasAttribute('data-booking')) {
      var d = form.querySelector('[data-book-date]');
      var t = form.querySelector('[data-book-time]');
      if (!d || !d.value) {
        if (errBox) errBox.textContent = form.getAttribute('data-msg-date') || 'Elige una fecha.';
        if (d) d.focus();
        return;
      }
      if (!t || !t.value) {
        if (errBox) errBox.textContent = form.getAttribute('data-msg-time') || 'Elige una hora.';
        return;
      }
    }

    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-loading') || '...'; }

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          var m = res.body.description || res.body.message || 'No se pudo agregar.';
          if (errBox) errBox.textContent = m; else toast(m);
          return;
        }
        refreshCount();
        toast(form.getAttribute('data-msg-added') || 'Agregado al carrito');
        if (form.hasAttribute('data-goto-cart')) {
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        }
      })
      .catch(function () { toast('Error de conexión. Intenta de nuevo.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = b.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Portfolio: swatch filter ---------- */
  document.querySelectorAll('[data-folio]').forEach(function (root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.folio__item'));
    root.querySelectorAll('[data-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-filter');
        root.querySelectorAll('[data-filter]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        items.forEach(function (it, i) {
          var match = key === 'all' || it.getAttribute('data-family') === key;
          it.hidden = !match;
          it.setAttribute('data-index', i);
        });
      });
    });
  });

  /* ---------- Lightbox ---------- */
  var lb = document.getElementById('lightbox');
  if (lb) {
    var lbImg = lb.querySelector('[data-lb-img]');
    var lbCap = lb.querySelector('[data-lb-cap]');
    var pool = [], cursor = 0, lastFocus = null;

    function show(i) {
      if (!pool.length) return;
      cursor = (i + pool.length) % pool.length;
      var el = pool[cursor];
      var img = el.querySelector('img');
      lbImg.src = img.getAttribute('data-full') || img.currentSrc || img.src;
      lbImg.alt = img.alt || '';
      var tag = el.querySelector('.folio__tag');
      lbCap.innerHTML = tag ? tag.innerHTML : '';
    }
    function open(el) {
      var root = el.closest('[data-folio]') || document;
      pool = Array.prototype.slice.call(root.querySelectorAll('.folio__item')).filter(function (n) { return !n.hidden; });
      lastFocus = el;
      show(pool.indexOf(el));
      lb.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      lb.querySelector('.lb__close').focus();
    }
    function close() {
      lb.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
      lbImg.src = '';
      if (lastFocus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var item = e.target.closest('.folio__item');
      if (item) { open(item); return; }
      if (e.target.closest('[data-lb-close]')) { close(); return; }
      if (e.target.closest('[data-lb-prev]')) { show(cursor - 1); return; }
      if (e.target.closest('[data-lb-next]')) { show(cursor + 1); return; }
      if (e.target === lb) close();
    });
    document.addEventListener('keydown', function (e) {
      if (lb.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(cursor - 1);
      if (e.key === 'ArrowRight') show(cursor + 1);
    });
  }

  /* ---------- PDP gallery thumbs ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-src');
        main.alt = t.querySelector('img') ? t.querySelector('img').alt : '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (o) {
          o.setAttribute('aria-pressed', String(o === t));
        });
      });
    });
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-variant-json]').textContent);
    var idField = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-variant-price]');
    var btn = root.querySelector('[data-add-btn]');

    function update() {
      var chosen = Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (s) { return s.value; });
      var match = data.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];
      if (!match) return;
      idField.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = (match.compare_at_price > match.price ? '<s>' + money(match.compare_at_price) + '</s> ' : '') + money(match.price);
      }
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available
          ? (btn.getAttribute('data-label') || 'Agregar')
          : (btn.getAttribute('data-sold') || 'Agotado');
      }
    }
    root.querySelectorAll('[data-option-index]').forEach(function (s) { s.addEventListener('change', update); });
    update();
  });

  /* ---------- Scroll reveal ---------- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (t) { t.setAttribute('data-in', 'true'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.setAttribute('data-in', 'true');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ---------- Mark today's row in hours ---------- */
  document.querySelectorAll('[data-weekday]').forEach(function (row) {
    if (parseInt(row.getAttribute('data-weekday'), 10) === new Date().getDay()) {
      row.setAttribute('data-today', 'true');
    }
  });

  refreshCount();
})();
